import instance from '../scorpiusInstance';
import {
  ASSIGN_PERMISSIONS_TO_ROLES_START,
  ASSIGN_PERMISSIONS_TO_ROLES_SUCCESS,
  ASSIGN_PERMISSIONS_TO_ROLES_ERROR,
} from '../types';

export const assignPermissionsToRolesStart = (orgId, appName) => ({
  type: ASSIGN_PERMISSIONS_TO_ROLES_START,
  orgId,
  appName,
});

export const assignPermissionsToRolesSuccess = (orgId, appName, role) => ({
  type: ASSIGN_PERMISSIONS_TO_ROLES_SUCCESS,
  orgId,
  appName,
  role,
});

export const assignPermissionsToRolesError = (orgId, appName, error) => ({
  type: ASSIGN_PERMISSIONS_TO_ROLES_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Updates a role belonging to an organization's app.
 * @param {String} orgId
 * @param {String} appName
 * @param {Object} payload
 * @param {String} payload.role_ids - Required
 * @param {String} payload.permission_names - Required
 */
export const assignPermissionsToRoles =
  (orgId, appName, payload) => async dispatch => {
    dispatch(assignPermissionsToRolesStart(orgId, appName));
    try {
      const response = await instance.patch(
        `/organizations/${orgId}/${appName}/data-sources`,
        payload,
        { headers: { retry: true } },
      );
      return dispatch(
        assignPermissionsToRolesSuccess(orgId, appName, response.data),
      );
    } catch (error) {
      throw dispatch(assignPermissionsToRolesError(orgId, appName, error));
    }
  };

export default assignPermissionsToRoles;
